import axios from "axios";
import { getLang } from "@/i18n";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});
api.interceptors.request.use((c) => { c.headers["X-Lang"] = getLang(); return c; });

export const errMsg = (e) => e?.response?.data?.detail
  ? (typeof e.response.data.detail === "string" ? e.response.data.detail : "Please check the form fields.")
  : "Something went wrong. Please retry.";

export const LANGS = ["English", "Spanish", "Italian", "French", "Portuguese", "German", "Dutch", "Greek", "Croatian", "Polish"];
export const COUNTRIES = ["Spain", "Portugal", "Italy", "France", "Greece", "Croatia", "Germany", "Netherlands", "Austria", "Other"];

export const startCheckout = async (lookup_key, email) => {
  const { data } = await api.post("/payments/checkout", { lookup_key, origin_url: window.location.origin, email });
  window.location.href = data.checkout_url;
};
